import api from './APIService';

class AMAService {
	validateAMA($data) {
		return api.fetch({ method: 'post', path: '/participant/membership/validate-ama', data: $data});
	}
    getAMAbyUserId($userId, $orgName) {
        return api.fetch({ method: 'get', path: `/participant/memberships/current-ama/${$userId}/${$orgName}`});
    }
    getAMAId(){
        return api.fetch({ method: 'get', path: `/participant/membership/ama-id`});
    }
    getValidationAPI(){
        return api.fetch({ method: 'get', path: `/participant/organization/available-d14-url`});
    }
    getAMAD14(){
        return api.fetch({ method: 'get', path: `/participant/membership/ama-d14-id`});
    }
    getAMAD14byUserId($userId, $orgName) {
        return api.fetch({ method: 'get', path: `/participant/memberships/current-ama/${$userId}/${$orgName}`});
    }
    validateAMAD14($data) {
		return api.fetch({ method: 'post', path: '/participant/membership/validate-d14', data: $data});
	}
}

export default new AMAService();
